export default "__VITE_ASSET__d3ef49b7__"